function isObject(x) {
  return typeof x === 'object' && x !== null;
}

export default function deepMerge(left, right) {
  let result = { ...left };
  Object.entries(right).forEach(([key, value]) => {
    if (isObject(result[key]) && isObject(value)) {
      result[key] = deepMerge(result[key], value);
    } else {
      result[key] = value;
    }
  });
  return result;
}
